export class KYMW0905OutputModel {
  /**
   * 受注コード
   */
  public orderCode: string = <string>'';

  /**
   * Ｐコード
   */
  public pCode: string = <string>'';

  /**
   * アイテムコード
   */
  public itemCode: string = <string>'';

  /**
   * 分析連番
   */
  public analysisSeqNo: string = <string>'';

  /**
   * 分析単位
   */
  public analysisUnit: string = <string>'';

  /**
   * 栄養成分備考
   */
  public nutritionalNote: string = <string>'';

  /**
   * 栄養成分リスト
   */
  public nutrientDetailList: any = new Array<any>();

  /**
   * 編集モード
   * "I" : コンテキストメニュー「栄養成分新規登録」での呼び出し
   * "U" : コンテキストメニュー「栄養成分メンテナンス」での呼び出し
   */
  public editMode: string = <string>'';
}
